import type { RGBColor } from "common/types/colors";

export const DEFAULT_EVENT_COLOR: RGBColor = { r: 171, g: 244, b: 255 };
export const DEFAULT_PERSONAL_EVENT_COLOR: RGBColor = {
  r: 153,
  g: 229,
  b: 196,
};
export const UNPUBLISHED_EVENT_COLOR_FACTOR: number = 0.4;
